// extracted by mini-css-extract-plugin
export default {"control":"ProfileContent_control__Qskw1","flexContainer":"ProfileContent_flexContainer__bHo3r"};